import { render, staticRenderFns } from "./center3.vue?vue&type=template&id=117529eb&scoped=true"
import script from "./center3.vue?vue&type=script&lang=js"
export * from "./center3.vue?vue&type=script&lang=js"
import style0 from "./center3.vue?vue&type=style&index=0&id=117529eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117529eb",
  null
  
)

export default component.exports